module.exports = __webpack_public_path__ + "static/img/dynamict.dc42122.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamict.png
// module id = ElEb
// module chunks = 45